import React, { useEffect } from "react";
import Preloader from "../helper/Preloader";
import ColorInit from "../helper/ColorInit";
import HeaderTwo from "../components/Header";
import Breadcrumb from "../components/Breadcrumb";
import FooterTwo from "../components/Footer";
import BottomFooter from "../components/BottomFooter";
import CartSection from "../components/CartSection";
import ShippingOne from "../components/ShippingOne";
import ScrollToTop from "react-scroll-to-top";
import { useDispatch, useSelector } from "react-redux";
import { fetchCart } from "../features/cart/cartSlice";


const CartPage = () => {
  const dispatch = useDispatch();
  const {loading, items, totalSummary, error} = useSelector(state => state.cartProductList)

  useEffect(() => {
    dispatch(fetchCart())
  }, [dispatch])

  return (
    <>
      {loading ? (
        <> 
          <ColorInit color={true} />
          <ScrollToTop smooth color="#FA6400" />
          <Preloader />
        </>
      ) : (
        <> 
          <Breadcrumb title={"Cart"} />
          <CartSection items={items}  totalSummary={totalSummary}/>
          <ShippingOne />
        </>
      )}
    </>
  );
};

export default CartPage;
